import { gsap } from 'gsap'
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
gsap.registerPlugin(DrawSVGPlugin)

/**
 * LogoAnimation functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class LogoAnimation {
  /**
     * Constructs a new LogoAnimation instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.letterT = this.element.querySelector('#T')
    this.letterL = this.element.querySelector('#L')
    this.letterD = this.element.querySelector('#D')
    this.line1Path = this.element.querySelector('#line_3 path')
    this.line2Path = this.element.querySelector('#line_2 path')
    this.line3Path = this.element.querySelector('#line_1 path')

    const loadingTL = gsap.timeline({ delay: 0.5, repeat: -1, repeatDelay: 2, paused: false })

    // this.loadingTL = new TimelineMax({  });
    loadingTL.to(this.letterT, 0.5, { scale: 1, opacity: 1, transformOrigin: 'center' })
      .fromTo(this.line1Path, 0.5, { drawSVG: "100% 100%", opacity: 0 }, { drawSVG: "0 100%", opacity: 1 })
      .to(this.letterD, 0.5, { scale: 1, opacity: 1, transformOrigin: 'center' })
      .fromTo(this.line2Path, 0.5, { drawSVG: "100% 100%", opacity: 0 }, { drawSVG: "0 100%", opacity: 1 })
      .to(this.letterL, 0.5, { scale: 1, opacity: 1, transformOrigin: 'center' })
      .fromTo(this.line3Path, 0.5, { drawSVG: "100% 100%", opacity: 0 }, { drawSVG: "0 100%", opacity: 1 })
  }
}